import OrderStatusDetail from "./OrderStatusDetail";

export default OrderStatusDetail;
